export class PostJoineeDTO {
  joinees: Joinee[] = [];
  referralCode: string = '';

  constructor(data: Partial<PostJoineeDTO> = {}) {
    this.referralCode = data.referralCode ?? '';
    this.joinees = (data.joinees ?? []).map(j => new Joinee(j));
  }
}

export class Joinee {
  wasRespectfull: boolean = false;
  wasOnTime: boolean = false;
  userId: number = 0;

  constructor(data: Partial<Joinee> = {}) {
    Object.assign(this, data);
  }
}
